import Customer from '@/models/Customer';

export default function formatCustomer(customer: Customer) {
    if (customer.civility === 'M.' || customer.civility === 'Mme.') {
        return `${customer.first_lastname} ${customer.first_firstname}`;
    } else if (
        customer.civility === 'M. et Mme.' ||
        customer.civility === 'M. et M.' ||
        customer.civility === 'Mme. et Mme.'
    ) {
        return `${customer.first_lastname} ${customer.first_firstname} - ${
            customer.second_lastname
        } ${customer.second_firstname}`;
    } else if (customer.civility === 'Société') {
        return customer.company_name;
    }

    return '';
}
